import { Modal, Button, Form, Row, Col, Dropdown } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactCountryFlag from "react-country-flag";
import { countries } from "../../constants";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { getIntouch } from "../../../api.services.js/others.js";
import { useCounterStore } from "../../../store/useConterStore.js";
import axios from "axios";
import "flatpickr/dist/themes/airbnb.css";
import Flatpickr from "react-flatpickr";

const timeSlots = [
  { label: "9:00 AM", value: 9 },
  { label: "9:30 AM", value: 9 },
  { label: "10:00 AM", value: 10 },
  { label: "10:30 AM", value: 10 },
  { label: "11:00 AM", value: 11 },
  { label: "11:30 AM", value: 11 },
  { label: "12:00 PM", value: 12 },
  { label: "12:30 PM", value: 12 },
  { label: "1:00 PM", value: 13 },
  { label: "1:30 PM", value: 13 },
  { label: "2:00 PM", value: 14 },
  { label: "2:30 PM", value: 14 },
  { label: "3:00 PM", value: 15 },
  { label: "3:30 PM", value: 15 },
  { label: "4:00 PM", value: 16 },
  { label: "4:30 PM", value: 16 },
  { label: "5:00 PM", value: 17 },
  { label: "5:30 PM", value: 17 },
  { label: "6:00 PM", value: 18 },
  { label: "6:30 PM", value: 18 },
  { label: "7:00 PM", value: 19 },
  { label: "7:30 PM", value: 19 },
  { label: "8:00 PM", value: 20 },
];

export default function ProfessionalDesignConsultationModal() {
  const { premiumForm, setPremiumForm, sourceId } = useCounterStore();

  const [hours, setHours] = useState(["Select Date First"]);

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Name should only contain letters and spaces"),
    phone: Yup.string()
      .length(10, "Must be 10 digits")
      .matches(/^\d+$/, "Must be numeric")
      .required("Mobile number is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid Email format"),
    pincode: Yup.string()
      .length(6, "Invalid pincode")
      .required("Pincode is required"),
    countryCode: Yup.string().nullable(),
    cc: Yup.string().nullable(),
    date: Yup.mixed()
      .required("Date is required")
      .test("is-valid-date", "Please select a valid date", function (value) {
        if (!value) return false;
        const date = value instanceof Date ? value : new Date(value);
        return date instanceof Date && !isNaN(date.getTime());
      })
      .test("is-future-date", "Date must be today or later", function (value) {
        if (!value) return false;
        const date = value instanceof Date ? value : new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date >= today;
      }),
    timeSlot: Yup.string().required("Time slot is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      pincode: "",
      countryCode: "",
      cc: "",
      date: "",
      timeSlot: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        const response = await getIntouch({
          ...values,
          call_id: sourceId ?? "book-an-appointment",
        });

        if (response?.name && response?.name === "ApolloError") {
          throw new Error(response.message);
        }

        // Show success message
        swal(
          "Consultation Confirmed Successfully!",
          "Our experts will contact you soon.",
          "success"
        );

        // Reset the form after successful submission and close the modal
        resetForm();
        setPremiumForm(false);
      } catch (error) {
        console.error("Error submitting form:", error);
        swal("Error", "Something went wrong. Please try again later.", "error");
      } finally {
        setHours(["Select Date First"]);
        setSubmitting(false);
      }
    },
  });

  const handleDateChange = async (e) => {
    try {
      setHours(["Loading..."]);
      const date = new Date(e[0]);
      formik.setFieldValue("date", date);

      // add cache for time slots so that we don't hit the API every time
      // Fetch available time slots for the selected date
      const response = await axios.get(
        `https://proxy.orientbell.com/get/timeslots?date=${date.toISOString()}`
      );

      setHours(response.data.timeslots);
    } catch (error) {
      // if date is today, filter out past hours
      if (
        new Date().setHours(0, 0, 0, 0) === new Date(date).setHours(0, 0, 0, 0)
      ) {
        setHours(
          timeSlots
            .filter((slot) => +slot.value > +new Date().getHours())
            .map((slot) => slot.label)
        );
      }
      // if date is in the future
      if (new Date().setHours(0, 0, 0, 0) < new Date(date).setHours(0, 0, 0, 0))
        setHours(timeSlots.map((slot) => slot.label));
    }
  };

  return (
    <Modal
      show={premiumForm}
      onHide={() => {
        setPremiumForm(!premiumForm);
        formik.resetForm();
        setHours(["Select Date First"]);
      }}
      className="consultation-popup"
      centered
      size="md"
    >
      <Modal.Header closeButton style={{ backgroundColor: "#fff" }}>
        <Modal.Title>Book a Consultation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="consul-pl-row">
          <div className="consul-pl-col left">
            <div>
              <ul className="mb-0" style={{ textAlign: "center" }}>
                <li>Making tile buying journey easy with expert advice</li>
              </ul>
            </div>
          </div>
        </div>

        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                {/* Name */}
                <Form.Control
                  name="name"
                  placeholder="Full Name*"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  isInvalid={formik.touched.name && formik.errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Mobile */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  name="phone"
                  placeholder="Mobile Number*"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  isInvalid={formik.touched.phone && formik.errors.phone}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.phone}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {/* Email */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  isInvalid={formik.touched.email && formik.errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Pincode */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="number"
                  name="pincode"
                  placeholder="Pincode*"
                  value={formik.values.pincode}
                  onChange={formik.handleChange}
                  isInvalid={formik.touched.pincode && formik.errors.pincode}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.pincode}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          {/* Date */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Flatpickr
                  options={{
                    minDate: "today",
                    dateFormat: "Y-m-d",
                    disableMobile: true,
                    locale: "en", // change if needed
                  }}
                  name="date"
                  placeholder="Select Date*"
                  className="form-control"
                  value={formik.values.date}
                  onChange={handleDateChange}
                  // isInvalid={formik.touched.date && formik.errors.date}
                  // onBlur={() => formik.setFieldTouched("date", true)}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.date}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Time */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Select
                  name="timeSlot"
                  value={formik.values.timeSlot}
                  onChange={formik.handleChange}
                  isInvalid={formik.touched.timeSlot && formik.errors.timeSlot}
                >
                  <option value="">Pick a Slot</option>
                  {hours.map((slot, index) => (
                    <option
                      key={index}
                      value={slot === "Select Date First" ? "" : slot}
                    >
                      {slot}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {formik.errors.timeSlot}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <span
            style={{ fontSize: "11px", color: "#6c757d", lineHeight: "16px" }}
          >
            <strong
              style={{ fontSize: "11px", color: "#000", lineHeight: "16px" }}
            >
              Note:{" "}
            </strong>
            Please ensure a stable internet connection and be available at your
            chosen time.
          </span>

          <Button
            type="submit"
            onClick={formik.handleSubmit}
            variant="warning"
            className="w-100"
            disabled={formik.isSubmitting}
            style={{ borderRadius: "99px", color: "#fff" }}
          >
            {formik.isSubmitting ? "Submitting..." : "Book Now"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
